import React, { FC } from 'react';
import { Tabs as ReactTabs, TabsProps } from 'react-tabs';

const Tabs: FC<TabsProps> = ( props ) => {
  return <ReactTabs {...props} selectedTabClassName="text-blue-500 border-b-2 font-medium border-blue-500" />
}

export default Tabs;